import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BrowserDetector from './BrowserDetector';
import detectBrowser from '../../lib/detectBrowser';
import UserData from './UserData';
import WrappedAccountRep from './WrappedAccountRep';
import WrappedHeaderNav from './WrappedHeaderNav';
import { Footer } from '@forwardfinancing/component-library';
import { trackException } from '@forwardfinancing/analytics-frontend-library/index';
import SomethingWentWrongMessage from './SomethingWentWrongMessage';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorInfo: null };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true, errorInfo: info });
  }

  render() {
    let browser = null;
    if (navigator && navigator.userAgent) {
      browser =
        detectBrowser(navigator.userAgent) ? detectBrowser(navigator.userAgent).name : null;
    }

    if (this.state.hasError) {
      const { errorInfo } = this.state;
      trackException({ errorInfo });

      return (
        <div className='app rebrand'>
          <SomethingWentWrongMessage />
        </div>
      );
    }

    return (
      <div className={`app rebrand ${browser ? browser : ''}`}>
        <WrappedHeaderNav/>
        <UserData exceptOn={['/owner/sign_in']} />
        <BrowserDetector browserName={browser}/>
        <div className="app__content container centered-at-tab centered-at-phone">
          {this.props.children}
          <WrappedAccountRep />
        </div>
        <Footer />
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

export default App;
